import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { getAssetFilePath } from '../../summary/common/get_asset_file_path';

const useStyles = createUseStyles((theme) => ({
    container: {
        position: 'relative'
    },
    img: {
        position: 'absolute',
        right: 0,
        bottom: 0,
        objectFit: 'cover',
        objectPosition: 'top',
        width: '20.1rem'
    },
    clip: {
        height: '16.3rem'
    },
    full: {
        height: '23.5rem'
    }
}));

const AlexanderHalfPicture = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { full } = props;

    const imgSrc = getAssetFilePath('/assets/brand/ctm/images/alexander_half_excited_pose.png');

    // Note: that alt text has been set to empty because this is a Decorative Image - supplying alt text here
    // is only a distraction for visually impaired users - ensure that relevant alt text is included for any
    // informative, descriptive, or functional images / icons
    return (
        <div className={classNames('test-policyFilters-alexHalfPose', classes.container)}>
            <img alt={''} src={imgSrc} className={classNames(classes.img, full ? classes.full : classes.clip)} />
        </div>
    );
};

AlexanderHalfPicture.propTypes = {
    full: PropTypes.bool
};

export { AlexanderHalfPicture };
